import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2b78338"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_career_input_layout_column_2" }
const _hoisted_2 = { class: "entry_career_input_layout_column_2_item" }
const _hoisted_3 = { class: "entry_career_input_layout_column_2_item_inner" }
const _hoisted_4 = { class: "entry_career_input_layout_column_2_item_inner_select" }
const _hoisted_5 = { class: "entry_career_input_layout_column_2_item_inner_suffix" }
const _hoisted_6 = { class: "entry_career_input_layout_column_2_item_inner_suffix_text" }
const _hoisted_7 = { class: "entry_career_input_layout_column_2_item" }
const _hoisted_8 = { class: "entry_career_input_layout_column_2_item_inner" }
const _hoisted_9 = { class: "entry_career_input_layout_column_2_item_inner_select" }
const _hoisted_10 = { class: "entry_career_input_layout_column_2_item_inner_suffix" }
const _hoisted_11 = { class: "entry_career_input_layout_column_2_item_inner_suffix_text" }

import { PropType, computed, ref, Ref, watchEffect } from 'vue';
import BaseSelectBox, { Options } from '@/components/BaseSelectBox.vue';
import { thisYear } from '@/utils/dateFormat';

type ButtonType = 'button' | 'submit' | 'reset';
type ButtonTheme = 'primary' | 'secondary' | 'text' | 'tertiary';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseYmForm',
  props: {
  type: {
    type: String as PropType<ButtonType>,
    default: 'button',
  },
  theme: {
    type: String as PropType<ButtonTheme>,
    default: 'primary',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: String, // 'yyyy-MM'
    default: '',
  },
  minYm: {
    type: String, // 'yyyy-MM'
    default: '',
  },
  maxYm: {
    type: String, // 'yyyy-MM'
    default: '',
  },
  suffixYearText: {
    type: String,
    default: '年',
  },
  suffixMonthText: {
    type: String,
    default: '月',
  },
  yearSort: {
    type: String as PropType<'asc' | 'desc'>,
    default: 'asc',
  },
  hasCancelButton: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props



const propMinYear = computed(() => {
  if (!props.minYm) return '';
  return props.minYm.split('-')[0];
});

const propMaxYear = computed(() => {
  if (!props.maxYm) return '';
  return props.maxYm.split('-')[0];
});

const minYear = computed(() => propMinYear.value || '1960');
const maxYear = computed(() => propMaxYear.value || thisYear());

const yOptions: Ref<Options> = computed(() => {
  const opts: Options = [];
  for (let i = Number(minYear.value); i <= Number(maxYear.value); i++) {
    opts.push({ label: String(i), value: String(i) });
  }
  if (props.yearSort === 'desc') {
    opts.sort(function (a, b) {
      if (Number(a.value) > Number(b.value)) return -1;
      return 1;
    });
  }
  return opts;
});

const y = ref(props.modelValue.split('-')[0]) || '';
const m = ref(props.modelValue.split('-')[1]) || '';

const minMonth = computed(() => {
  if (props.minYm && propMinYear.value === y.value) {
    return props.minYm.split('-')[1];
  }
  return '01';
});

const maxMonth = computed(() => {
  if (props.maxYm && propMaxYear.value === y.value) {
    return props.maxYm.split('-')[1];
  }
  return '12';
});

const mOptions: Ref<Options> = computed(() => {
  const opts: Options = [];
  for (let i = Number(minMonth.value); i <= Number(maxMonth.value); i++) {
    const strI = i.toString().padStart(2, '0');
    opts.push({ label: String(i), value: strI });
  }
  return opts;
});



watchEffect(() => {
  if (y.value && (Number(minMonth.value) > Number(m.value) || Number(maxMonth.value) < Number(m.value))) {
    m.value = '';
  }
  if (y.value && m.value) {
    emit('update:modelValue', `${y.value}-${m.value}`);
  } else if (y.value) {
    emit('update:modelValue', `${y.value}-`);
  } else if (m.value) {
    emit('update:modelValue', `-${m.value}`);
  } else {
    emit('update:modelValue', '');
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(BaseSelectBox, {
            options: _unref(yOptions),
            placeholder: "2020",
            modelValue: _unref(y),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(y) ? (y).value = $event : null)),
            hasCancelButton: props.hasCancelButton
          }, null, 8, ["options", "modelValue", "hasCancelButton"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(props.suffixYearText), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(BaseSelectBox, {
            options: _unref(mOptions),
            placeholder: "1",
            modelValue: _unref(m),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(m) ? (m).value = $event : null)),
            hasCancelButton: props.hasCancelButton
          }, null, 8, ["options", "modelValue", "hasCancelButton"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(props.suffixMonthText), 1)
        ])
      ])
    ])
  ]))
}
}

})